module.exports = __webpack_public_path__ + "img/1U0ShfsJ.7b7ba5d4.jpg";